import { rootApi } from "../../api/rootApi";

export const pincodeApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchPincodes: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: "/admin/pincode-master",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                    },
                    body: params.body,
                };
            },
        }),
    }),
});
export const { useFetchPincodesMutation } = pincodeApi;
